import useInfiniteScroll from "../../../hooks/useInfiniteScroll";
import React, { FC, useState, useEffect, memo, useMemo } from "../../../lib/teact/teact";
import InfiniteScroll from "../../ui/InfiniteScroll";
import ListItem from "../../ui/ListItem";
import { isCuPhapMn } from "../utils/common";
import ItemDataCanChuyen from "./ItemDataCanChuyen";
import "./ItemDataCanChuyen.scss"
import ItemDataCanChuyenGroupTotal from "./ItemDataCanChuyenGroupTotal";
type OwnProps = {
    data: any;

}
const ListDataCanChuyen: FC<OwnProps> = ({
    data,
}) => {
    const buildListIds = useMemo(() => {
        const tmp: number[] = []
        data.dataCanChuyenStruct && data.dataCanChuyenStruct.map((item: any, index: number) => tmp.push(index))
        return tmp
    }, [data])
    const [viewportIds, getMore] = useInfiniteScroll(undefined, buildListIds, false, 100);
    let stt = 0;
    let preLoaiCuoc = "";
    
    return (
        <div className="list-container">
            <ListItem key={'litem:' + "header-0"} style="width:100%"
                className="chat-item-clickable contact-list-item">

                <div className="item-data" key="header-0"  >
                    {isCuPhapMn() ?
                        <div>
                            Đài
                        </div> :
                        <div>
                            Stt
                        </div>
                    }
                    <div>
                        Loại
                    </div>
                    <div>
                        Số
                    </div>
                    <div className="nhan">
                        Giữ
                    </div>
                    <div className="thua">
                        Thừa
                    </div>
                </div>

            </ListItem>
            <InfiniteScroll items={viewportIds} onLoadMore={getMore}
                className="chat-list custom-scroll"
                style="height:100%;"
            >
                {viewportIds && viewportIds.map((it, index) => {
                    const item = data.dataCanChuyenStruct[it]
                    // if (item.loaiCuocId != preLoaiCuoc) {
                    //     stt = 1;
                    // }
                    // else {
                    //     stt++;
                    // }
                    // preLoaiCuoc = item.loaiCuocId;

                    return (
                        <div key={"dtls-key-" + it} id={"dtls-id-" + it} style="width:100%;">
                            <ListItem className="Listitem-button-nopadding-all">
                                <ItemDataCanChuyen row={item} diemByStt={data.diemByStt} index={item.stt} dataCanChuyen={data} />
                            </ListItem>
                            {item.lastItem && <ItemDataCanChuyenGroupTotal data={data} curItem={item}></ItemDataCanChuyenGroupTotal>}
                        </div>
                    )
                })}
            </InfiniteScroll>
        </div>
    )
}

export default memo(ListDataCanChuyen)